import { useEffect, useState } from 'react';
import { AbsenceReportApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { ManagedProjectDto, UpcomingAbsenceDto } from '../../../commonTypes/reports.types';

export interface IGetUpcomingAbsencesQuery {
    month: number;
    year: number;
    teamId?: string;
    projectId?: string;
    leaveType?: string;
    search?: string;
    page: number;
    size: number;
    enabled?: boolean;
}

const useHttpGetUpcomingAbsences = (query: IGetUpcomingAbsencesQuery) => {
    const absenceReportApi: AbsenceReportApi = useContainer(AbsenceReportApi);
    const [data, setData] = useState<UpcomingAbsenceDto[]>([]);
    const [total, setTotal] = useState<number>(0);
    const [managedProjects, setManagedProjects] = useState<ManagedProjectDto[] | undefined>(undefined);
    const [isReady, setIsReady] = useState(false);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        if (query.enabled === false) return;

        setIsReady(false);
        const { exec, abort } = absenceReportApi.getUpcomingAbsences({
            query: {
                month: query.month,
                year: query.year,
                teamId: query.teamId,
                projectId: query.projectId,
                leaveType: query.leaveType,
                search: query.search,
                page: query.page,
                size: query.size,
            },
            onSuccess: res => {
                setData(res.body.content);
                setTotal(res.body.totalElements);
                setManagedProjects(res.body.managedProjects);
                setIsError(false);
            },
            onError: () => setIsError(true),
            onFinally: () => setIsReady(true),
        });
        exec();
        return abort;
    }, [query.month, query.year, query.teamId, query.projectId, query.leaveType, query.search, query.page, query.size, query.enabled]);

    return { data, total, managedProjects, isReady, isError };
};

export default useHttpGetUpcomingAbsences;
